import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'lib/utility/i18n';
import {
  FloatingLabelFormField,
  SelectControl
} from 'reactifi';

export default class PlaylistSelect extends React.Component {

  static propTypes = {
    accountPlaylists: PropTypes.array,
    globalPlaylists: PropTypes.array
  }

  constructor(props) {
    super(props);
  }

  render() {
    const { accountPlaylists, globalPlaylists } = this.props;

    return (
      <>
        <h5>{i18n.t('Available playlists')}</h5>
        <div>{i18n.t('Select default playlists available to all programs of this account.')}</div>
        <FloatingLabelFormField
          caption={i18n.t('Playlist Name')}
          dataValue={accountPlaylists}
          name="account[available_playlist_ids]"
        >
          <SelectControl
            labelKey="name"
            multi={true}
            options={globalPlaylists}
            valueKey="id"
          />
        </FloatingLabelFormField>
      </>
    )
  }
}
